import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { trackComponentUsageRendered } from '../analytics/useForgeUiAnalyticsEvent';
import { useMetricsContext } from '../context/metrics';
// Gets the count of props on a component
export var getPropCount = function getPropCount(componentCountMap, componentName, props) {
  var propsArray = Object.keys(props);
  propsArray.map(function (propName) {
    if (propName === 'children') {
      return;
    }
    if (componentCountMap[componentName].propCount[propName] !== undefined) {
      componentCountMap[componentName].propCount[propName] += 1;
    } else {
      componentCountMap[componentName].propCount[propName] = 1;
    }
  });
};

// Recursive function to get the total number of components and total number of props on a component
var _getCountAnalytics = function getCountAnalytics(forgeDoc) {
  var componentCountMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var componentName = forgeDoc.type;
  // Type String is not a component
  if (componentName === 'String') {
    return componentCountMap;
  }
  // Don't send Root count as it's always one
  if (componentName !== 'Root') {
    var hasComponentEncountered = componentCountMap[componentName] !== undefined;
    if (hasComponentEncountered) {
      componentCountMap[componentName].componentCount += 1;
    } else {
      componentCountMap[componentName] = {
        componentCount: 1,
        propCount: {}
      };
    }
    if (forgeDoc.props !== undefined) {
      getPropCount(componentCountMap, componentName, forgeDoc.props);
    }
  }
  forgeDoc.children.forEach(function (forgeDocChild) {
    _getCountAnalytics(forgeDocChild, componentCountMap);
  });
  return componentCountMap;
};
var createKey = function createKey(countMap) {
  var key = '';
  Object.keys(countMap).sort().forEach(function (componentName) {
    key += "".concat(componentName).concat(countMap[componentName].componentCount);
  });
  return key;
};
// Gets the total number of components and props to send for analytics
// Only sends when there is a new count of components that has not been sent before
export var useSendNodeCountAnalytics = function useSendNodeCountAnalytics(_ref) {
  var _forgeDoc$forgeReactM, _forgeDoc$forgeReactM2;
  var forgeDoc = _ref.forgeDoc,
    forgeEnvironment = _ref.forgeEnvironment,
    UIKitVersion = _ref.UIKitVersion;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useMetricsContext = useMetricsContext(),
    source = _useMetricsContext.page;
  var prevCountMap = React.useRef({});
  if (forgeDoc === undefined) {
    return;
  }
  var componentCount = _getCountAnalytics(forgeDoc);
  var componentCountAsKey = createKey(componentCount);

  // converting to a string here as a safety measure against mutations to the original forgeDoc object
  var forgeReactMajorVersion = (_forgeDoc$forgeReactM = (_forgeDoc$forgeReactM2 = forgeDoc.forgeReactMajorVersion) === null || _forgeDoc$forgeReactM2 === void 0 ? void 0 : _forgeDoc$forgeReactM2.toString()) !== null && _forgeDoc$forgeReactM !== void 0 ? _forgeDoc$forgeReactM : null;

  // compare if a previous count has already been sent for analytics
  if (!prevCountMap.current.hasOwnProperty(componentCountAsKey)) {
    prevCountMap.current = _objectSpread(_objectSpread({}, prevCountMap.current), {}, _defineProperty({}, componentCountAsKey, true));

    // NOTE: createAnalyticsEvent has a side effect of potentially mutating objects that are passed into it
    // Any objects passed in should not be reused or must be deep cloned first
    var components = {};
    for (var componentName in componentCount) {
      components[componentName] = {
        count: componentCount[componentName].componentCount,
        propCount: componentCount[componentName].propCount
      };
    }
    trackComponentUsageRendered(createAnalyticsEvent, {
      source: source,
      isLegacyUiKit: UIKitVersion === '1',
      forgeEnvironment: forgeEnvironment,
      components: components,
      forgeReactMajorVersion: forgeReactMajorVersion
    });
  }
};